module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-energy-university-hero-lowres.7923c11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-energy-university-hero-lowres.jpg
// module id = BL+3
// module chunks = 0